export const NON_SHOP_DEPARTMENT = 'Premium Nav - Non Shop';

export const SHOP_DEPARTMENT = 'Shop by department';
export const EXTRAS_DEPARTMENT = 'Extras';

export const MONEY_HIERARCHY = 'John Lewis Money';

export enum Category {
  SHOP = 'Shop',
  BRANDS = 'Brands',
  NEW_IN = 'New In',
  OUTLET = 'Outlet',
  MONEY = 'JL Money',
  SERVICES_EXPERIENCES = 'Services & Experiences',
  SERVICES = 'Services',
  HELP = 'Help',
}

export const MOBILE_MENU_TABS: readonly Category[] = [
  Category.SHOP,
  Category.BRANDS,
  Category.NEW_IN,
  Category.OUTLET,
  Category.MONEY,
];

export const DESKTOP_MENU_TABS: readonly Category[] = [
  Category.SHOP,
  Category.BRANDS,
  Category.NEW_IN,
  Category.OUTLET,
  Category.SERVICES,
  Category.SERVICES_EXPERIENCES,
  Category.MONEY,
];
